import transferMotivesReducer from './reducers';

export { default as transferMotivesTypes } from './types';
export { default as transferMotivesActions } from './actions';
export { default as transferMotivesSagas } from './sagas';

export default transferMotivesReducer;
